module.exports = __webpack_public_path__ + "img/ae.b62c8ca6.svg";